import { DateField, FunctionField, Labeled, ReferenceField, SimpleShowLayout, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import UpdateSupervisorDialog from "../UpdateSupervisorDialog";
import EmployeeField from "server/components/Fields/EmployeeField";
import { specialistRequests } from "api/specialistApi";
import { SpecialistStatuses } from "utils/constants";
import GiveAttestationDialog from "./Partials/GiveAttestationDialog";
import { SectionTitle } from "features/SectionTitle";

const SpecializationInfoSection = ({ statusId }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <SimpleShowLayout>
      <SectionTitle
        title="Специалност"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={3}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Специалност">
            <TextField
              source="specializationNameBg"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Специалност (EN)">
            <TextField
              source="specializationNameEn"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Учебен план">
            <ReferenceField
              source="curriculumId"
              reference={specialistRequests.getSpecialistCurriculaSelect()}
              emptyText="-"
            >
              <FunctionField
                render={rec =>
                  rec
                    ? `${rec.specializationNameBg}${rec.specializationTypeName ? ` (${rec.specializationTypeName})` : ""}`
                    : "-"
                }
              />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Вид прием">
            <ReferenceField
              source="receptionTypeId"
              reference={administrationRequests.getReceptionTypesSelect()}
              emptyText="-"
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="База за обучение">
            <ReferenceField
              source="trainingBuildingId"
              reference={specialistRequests.getTrainingBuildingsSelect()}
              emptyText="-"
            >
              <TextField source="buildingNameBg" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Записан на">
            <DateField
              source="enrolledOn"
              locales="bg-BG"
              showTime={false}
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
        >
          <Labeled label="Ръководител">
            <EmployeeField source="supervisorEmployeeId" />
          </Labeled>
          {statusId === SpecialistStatuses.Active && (
            <FunctionField
              render={rec => (
                <SecuredComponent permission={permissions.canManageSpecialistsSupervisor}>
                  <UpdateSupervisorDialog specialistId={rec?.id} />
                </SecuredComponent>
              )}
            />
          )}
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
        >
          <Labeled label="Статус">
            <TextField source="statusName" />
          </Labeled>
          {statusId === SpecialistStatuses.WaitingForAttestation && (
            <FunctionField
              render={rec => (
                <SecuredComponent permission={permissions.canMakeSpecialistsEligibleForGraduation}>
                  <GiveAttestationDialog specialistId={rec?.id} />
                </SecuredComponent>
              )}
            />
          )}
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default SpecializationInfoSection;
